import {mapActions, mapGetters, mapMutations, mapState} from 'vuex';

export default {
    data() {
        return {
            // would be nice to get this from .env
            asset_prefix: '/v3assets',
            laravel_env: process.env.NODE_ENV,
        }
    },
    methods: {
        ...mapMutations('search', ['setParameter', 'setFetching']),
        ...mapGetters('search', ['shouldSwitchHeadingTagForPath']),
        shouldSwitchHeadingTag() {
            return this.shouldSwitchHeadingTagForPath(this.$route.path);
        },
        isDevMode() {
            return (this.laravel_env === 'development') ? true : false;
        },
        spa_enabled() {
            return (process.env.MIX_ENABLE_SPA.toLowerCase() == 'true' ? true : false);
        },
        asset_path(src) {
            return this.asset_prefix + src;
        },
        unpack_url(to) {
            // feel like we're re-inventing the wheel here            
            if (typeof(to) == 'object') {
                let href = null;

                if (typeof(to.name) != 'undefined') {
                    let route = this.$router.getRoutes().find(e => e.name == to.name);
                    href = route.path;
                } else {
                    // a "to" object passed to router-link normally would have path and query
                    href = to.path;
                }

                if (typeof(to.query) == 'string' && to.query != '') {
                    href += '?' + to.query;
                } else if (typeof(to.query) == 'object' && to.query instanceof URLSearchParams) {
                    href += (to.query.size > 0) ? '?' + to.query.toString() : '';
                } else if (typeof(to.query) == 'object' && Object.keys(to.query).length > 0) {
                    let u = new URLSearchParams(to.query);
                    href += '?' + u.toString();
                }
                return href;
            } else {
                return to;
            }
        },
        url_to_object(to) {
            if (typeof(to) == 'object') {
                return to;
            } else {
                // leverage the browser URL object
                let url = new URL(to, window.location.href);
                return {
                    path: url.pathname,
                    query: url.searchParams
                };
            }
        },
        link_to(href, withFetching = false) {
            let to = this.unpack_url(href);
            if (this.spa_enabled()) {
                this.$router.push(to);
            } else {
                if (withFetching) {
                    this.setFetching(true);
                }
                window.location.href = to;
            }
        },
        addressesForListings(branches) {
            if (typeof(branches) == 'undefined') { return {}; }
            let addr = {};
            let i = 0;
            let c = branches.length;
    
            if (c > 6) {
                let cur = {};
                let other = {};
                let b = null;
    
                // never figured out why the old code would ever NOT have position 0
                if (typeof branches[0] !== 'undefined') {
    
                    b = branches[0];
                    cur[b.Tag] = b.FullPostalAddress;
    
                    for (i = 1; i<c; i++) {
                        b = branches[i];
                        other[b.Tag] = b.Town;
                    }
    
                } else {
                    i = 0;
                    branches.forEach(function (b) {
                        if (i==0) {
                            cur[b.Tag] = b.FullPostalAddress;
                        } else {
                            let t = b.Town.trim();
                            other[b.Tag] = t;
                        }
                        i++;
                    })
                }
                const orderedOther = Object.keys(other).sort().reduce(
                    (obj, key) => { 
                      obj[key] = other[key]; 
                      return obj;
                    }, 
                    {}
                );            
                addr = { ...cur, ...orderedOther };
            } else {
                branches.forEach(function (b) {
                    addr[b.Tag] = b.FullPostalAddress;
                });
            }
            return addr;    
        }
    }
};
